import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function OAuthCallback(){
  const nav = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    const today = new Date().toISOString().slice(0,10);
    
    if (status === 'ok') {
      // Satisfy the current daily guard
      localStorage.setItem('pos_login_date', today);
      
      // Check if we're in a popup window (opened by reconnect flow)
      if (window.opener && !window.opener.closed) {
        // Notify parent window that OAuth completed successfully BEFORE closing
        try {
          window.opener.postMessage({ type: 'OAUTH_SUCCESS', status: 'ok' }, '*');
        } catch (e) {
          console.log('Could not post message to opener:', e);
        }
        // Small delay to ensure message is sent before closing
        setTimeout(() => window.close(), 100);
      } else {
        // Normal flow - navigate to home
        setTimeout(() => nav('/'), 100);
      }
    }
  }, [nav]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center space-y-2">
        <h1 className="text-2xl font-semibold" data-testid="oauth-callback-title">Finishing sign-in…</h1>
        <div className="text-sm opacity-70">Please wait…</div>
      </div>
    </div>
  );
}